<template>
  <Content class="col-span-full" :title="$route.name">
    <Notice class="mb-8">
      {{ $t('ROUTING_HISTORY_OVERVIEW_REPORT_NOTE') }}
    </Notice>

    <RoutingForm
      type="overview"
      @path="path = $event"
      @realtime="realtime = $event"
      @anomaly="anomalyPoints = $event"
      @startDateTime="startDateTime = $event"
      @endDateTime="endDateTime = $event"
      @vehicleId="vehicleId = $event"
      @minDuration="minDuration = $event"
    />

    <OverviewMap
      v-if="path != null"
      :tripDetail="path"
      :realtime="realtime"
      :vehicleId="vehicleId"
      :startDateTime="startDateTime"
      :endDateTime="endDateTime"
      :minDuration="minDuration"
    />
  </Content>
</template>
<script>
import Notice from '@/components/elements/notice'
import RoutingForm from '@/components/reports/history/RoutingForm'
import OverviewMap from '@/components/reports/history/OverviewMap.vue'

export default {
  components: {
    RoutingForm,
    OverviewMap,
    Notice,
  },
  data() {
    return {
      path: null,
      realtime: false,
      wrapperLoading: false,
      vehicleId: null,
      startDateTime: null,
      minDuration: null,
      endDateTime: null,
      alphaList: [
        {
          char: '',
        },
      ],
      speeds: [
        {
          data: [],
        },
      ],
      date: [],
    }
  },
  mounted() {},
}
</script>
